<svg
  class="pl__icon"
  viewBox="0 0 160 320"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  focusable="false"
>
  <g class="pl__guides">
    <path class="pl__line pl__line--thin" d="M 50 30 L 50 182" />
    <path class="pl__line pl__line--thin" d="M 110 30 L 110 182" />
    <path class="pl__line pl__line--thin" d="M 50 30 L 110 30" />
  </g>

  <circle
    class="pl__orbit pl__line pl__line--thin"
    cx="80"
    cy="245"
    r="30"
    stroke-dasharray="3 4"
  />

  <g class="pl__rod">
    <path class="pl__line" d="M 6 8 C 3 42, 10 70, 14 96" />
    <path class="pl__line" d="M -6 8 C -3 42, -10 70, -14 96" />
    <circle class="pl__line" cx="0" cy="105" r="18" />
    <circle class="pl__line pl__line--thin" cx="0" cy="105" r="11" />
  </g>

  <g class="pl__piston">
    <path
      class="pl__line"
      d="M -26 -73 Q -26 -78 -21 -78 L 21 -78 Q 26 -78 26 -73 L 26 7 Q 26 12 21 12 L -21 12 Q -26 12 -26 7 Z"
    />
    <path class="pl__line pl__line--thin" d="M -21 -66 L 21 -66" />
    <path class="pl__line pl__line--thin" d="M -21 -59 L 21 -59" />
    <path class="pl__line pl__line--thin" d="M -21 -52 L 21 -52" />
    <circle class="pl__line" cx="0" cy="0" r="10" />
    <circle class="pl__line pl__line--thin" cx="0" cy="0" r="4.5" />
  </g>

  <circle class="pl__dot" cx="80" cy="245" r="3.5" />
</svg>

@if (text(); as caption) {
  <span class="pl__text" aria-hidden="true">{{ caption }}</span>
}
